<template>
    <div>
        <resultFilter @searchForm="getSearchForm"></resultFilter>
        <div class="analysis_content">
            <div class="analysis_warp">
                <div class="analysis_title">业绩概览 <span>{{oSearchForm.start+' ~ '+oSearchForm.end}}</span></div>
                <div class="agent_warp_content">
                    <div class="agent">
                        <div class="agent_content">
                            <div class="agent_warp">
                                <div>
                                    签约金额
                                </div>
                                <div>
                                    (万)
                                </div>
                                <div class="agent_num">
                                    {{oOverview.money ? oOverview.money : "0"}}
                                </div>
                            </div>
                        </div>
                        <div class="agent_content">
                            <div class="agent_warp">
                                <div>
                                    上线潜客
                                </div>
                                <div>
                                    (位)
                                </div>
                                <div class="agent_num">
                                    {{oOverview.online ? oOverview.online : "0"}}
                                </div>
                            </div>
                        </div>
                        <div class="agent_content">
                            <div class="agent_warp">
                                <div>
                                    签约项目
                                </div>
                                <div>
                                    (单)
                                </div>
                                <div class="agent_num">
                                    {{oOverview.project ? oOverview.project : "0"}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="detailed" @click="$router.push({ path: '/performance/result/list' })">点击查看项目清单</div>
                </div>
                <!-- 业绩趋势 -->
                <div class="analysis_title">业绩趋势 <span>{{oSearchForm.start+' ~ '+oSearchForm.end}}</span></div>
                <div class="result-tab-wrap">
                    <div :class="['result-tab-item', trendTab === index && 'result-tab-item-act']" v-for="(item, index) in tabList" @click="getSwitch('trendTab',index)" :key="index">{{ item.name }}</div>
                </div>
                <!-- 折线图 -->
                <div id="delivery"></div>
                <div class="follow-table">
                    <div class="follow-table-top">
                        <div class="follow-table-top-item">签单总额</div>
                        <div class="follow-table-top-item">签约项目</div>
                        <div class="follow-table-top-item">登录客户</div>
                    </div>
                    <div class="follow-table-bottom">
                        <div class="follow-table-bottom-item" v-for="(item,index) in sOverviewNumber" :key="index">
                            <img :src="item.type === 'down' ? sDownImg : sUpImg" alt="">
                            <div :class="item.type === 'down' ? 'down' : 'up'">{{item ? item.value :"0"}}%</div>
                        </div>
                        <!-- <div class="follow-table-bottom-item">
                            
                            <div class="down">{{sOverviewNumber.length==3 ? sOverviewNumber[1].value :"0"}}%</div>
                        </div>
                        <div class="follow-table-bottom-item">
                            <img src="../../../assets/images/result/up.png" alt="">
                            <div class="up">{{sOverviewNumber.length==3 ? sOverviewNumber[2].value :"0"}}%</div>
                        </div> -->
                    </div>
                </div>
                <div class="radio_content">
                    <div class="radio-wrap">
                        <div class="radio-item" v-for="(item,index) in arrRabid" :key="index" @click="getIsfollow('arrRabid',index)">
                            <img :src="item.open ? selectImg : noSelectImg" alt="">
                            <div>{{item.name}}</div>
                        </div>
                    </div>
                    <div class="radio-wrap">
                        <div class="radio-item" v-for="(item,index) in arrYear" :key="index" @click="getIsfollow('arrYear',index)">
                            <img :src="item.open ? selectImg : noSelectImg" alt="">
                            <div>{{item.name}}</div>
                        </div>
                    </div>
                </div>
                <!-- 线 -->
                <div class="xian"></div>
                <div class="analysis_title">业绩榜单 <span>{{oSearchForm.start+' ~ '+oSearchForm.end}}</span></div>
                <div class="result_board">
                    <div class="result-tab-wrap" style="width:65%;">
                        <div :class="['result-tab-item', billboardTab === index && 'result-tab-item-act']" :style="{'width':100 / arrRankTab.length+'%'}" v-for="(item, index) in arrRankTab"
                            @click="getSwitch('billboardTab',index)" :key="index">
                            {{ item.name }}</div>
                    </div>
                    <div class="result-tab-wrap" style="width:30%;margin-left: 0px;">
                        <div :class="['result-tab-item', billboardDateTab === index && 'result-tab-item-act']" style="width:50%" v-for="(item, index) in arrMoney" @click="getSwitch('billboardDateTab',index)"
                            :key="index">{{ item.name }}</div>
                    </div>
                </div>
                <!-- 排行榜 -->
                <div class="ranking">
                    <div class="ranking_item">
                        <div class="rank_header">
                            <!-- <div class="rank_header_img">
                                <div class="header_url">
                                    <img :src="arrRankTopList.length >=2 ? arrRankTopList[1].head_pic : ''" alt="">
                                </div>
                                <div class="rank_header_num">No.2</div>
                            </div> -->
                            <div class="rank_sumpmer">No.2</div>
                            <div class="rank_number">
                                {{arrRankTopList.length >=2 ? arrRankTopList[1].value : ''}}
                            </div>
                            <div class="rank_name">
                                {{arrRankTopList.length >=2 ? arrRankTopList[1].name : ''}}
                            </div>
                            <div class="rank_address">
                                {{arrRankTopList.length >=2 ? arrRankTopList[1].title : ''}}
                            </div>
                        </div>
                        <!-- <div class="rank_num">
                            <div class="rank_content">
                                <span>NO.2</span><span class="set_num">{{arrRankTopList.length>=2 ? arrRankTopList[1].value : ''}}</span>
                            </div>
                        </div> -->
                    </div>
                    <div class="ranking_item">
                        <div class="rank_header_one">
                            <!-- <div class="rank_header_img">
                                <div class="header_url">
                                    <img :src="arrRankTopList.length ? arrRankTopList[0].head_pic : ''" alt="">
                                </div>
                                <div class="rank_header_num">No.1</div>
                            </div> -->
                            <div class="rank_sumpmer rank_sumpmer_one">No.1</div>
                            <div class="rank_number">
                                {{arrRankTopList.length ? arrRankTopList[0].value : ''}}
                            </div>
                            <div class="rank_name">
                                {{arrRankTopList.length ? arrRankTopList[0].name : ''}}
                            </div>
                            <div class="rank_address">
                                {{arrRankTopList.length ? arrRankTopList[0].title : ''}}
                            </div>
                        </div>
                        <div class="rank_num_two">
                            业绩榜单第一
                        </div>
                        <!-- <div class="rank_num_one">
                            <div class="rank_content_one">
                                <span>NO.1</span><span class="set_num_one">{{arrRankTopList.length ? arrRankTopList[0].value : ''}}</span>
                            </div>
                        </div> -->
                    </div>
                    <div class="ranking_item">
                        <div class="rank_header">
                            <!-- <div class="rank_header_img">
                                <div class="header_url">
                                    <img :src="arrRankTopList.length >=3 ? arrRankTopList[2].head_pic : ''" alt="">
                                </div>
                                <div class="rank_header_num">No.3</div>
                            </div> -->
                            <div class="rank_sumpmer">No.3</div>
                            <div class="rank_number">
                                {{arrRankTopList.length >=3 ? arrRankTopList[2].value : ''}}
                            </div>
                            <div class="rank_name">
                                {{arrRankTopList.length >=3 ? arrRankTopList[2].name : ''}}
                            </div>
                            <div class="rank_address">
                                {{arrRankTopList.length >=3 ? arrRankTopList[2].title : ''}}
                            </div>
                        </div>
                        <!-- <div class="rank_num">
                            <div class="rank_content">
                                <span>NO.3</span><span class="set_num">{{arrRankTopList.length>=3 ? arrRankTopList[2].value : ''}}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="contribute-table">
                    <el-table :data="arrRankList" style="width: 100%" :header-row-style="{ color: '#318544', border: 'none' }" :cell-style="cellStyle">
                        <el-table-column align="center" prop="date" label="排名" width="60">
                            <template slot-scope="scope">
                                <div>{{rankHandler(scope.$index)}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="name" :label="arrRankTab[billboardTab].name" :width="billboardTab==0 ? '70' :'auto'">
                            <template slot-scope="scope">
                                <div class="name">
                                    {{scope.row.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="title" label="所属公司" v-if="billboardTab==0">
                        </el-table-column>
                        <el-table-column align="center" prop="value" label="业绩" width="110">
                            <template slot-scope="scope">
                                <div class="flc-scope">
                                    <div class="amount">{{scope.row.value}}</div>
                                    <div class="flc">
                                        <img :src="scope.row.type === 'up' ? upIcon : downIcon" alt="">
                                        <div :style="{ color: scope.row.type === 'up' ? '#318544' : '#EB6F56' }">{{scope.row.rank_change}}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- <div class="more" @click="rankMore">点击查看更多</div> -->
                <div class="page-wrap">
                    <el-performance :page="nRankPage" :nNumber="nRankTotal" @next="nextRank" @last="lastRank" @active="getRankActive" :bBackfoued="false"></el-performance>
                </div>
            </div>
            <div class="analysis_warp">
                <div class="analysis_title">业绩预警 <span>{{oSearchForm.start+' ~ '+oSearchForm.end}}</span></div>
                <div class="result_board">
                    <div class="result-tab-wrap" style="width:65%;">
                        <div :class="['result-tab-item', warningTab === index && 'result-tab-item-act']" :style="{'width':100 / arrWarningTab.length+'%'}" v-for="(item, index) in arrWarningTab"
                            @click="getSwitch('warningTab',index)" :key="index">
                            {{ item.name }}</div>
                    </div>
                    <div class="result-tab-wrap" style="width:30%;margin-left: 0px;">
                        <div :class="['result-tab-item', warningDateTab === index && 'result-tab-item-act']" :style="{'width':100 / arrKedan.length+'%'}" v-for="(item, index) in arrKedan"
                            @click="getSwitch('warningDateTab',index)" :key="index">
                            {{ item.name }}</div>
                    </div>
                </div>
                <div class="contribute-table">
                    <el-table :data="arrWarningList" style="width: 100%" :header-row-style="{ color: '#318544', border: 'none' }" :cell-style="cellStyle">
                        <el-table-column align="center" prop="name" :label="arrWarningTab[warningTab].name" :width="warningTab==0 ? '80': 'auto'">
                            <template slot-scope="scope">
                                <div class="name">
                                    {{scope.row.name}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="warningTab==0" align="center" prop="title" label="所属公司">
                        </el-table-column>
                        <el-table-column align="center" prop="num" label="预警次数" :width="warningTab==0 ? '80': 'auto'">
                            <template slot-scope=" scope">
                                <div class="yj">
                                    {{scope.row.num}}
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="page-wrap">
                    <el-performance :page="nWarningPage" :nNumber="nWarningTotal" @next="nextWarning" @last="lastWarning" @active="getWarningActive" :bBackfoued="false"></el-performance>
                </div>
                <div class="contribute_radio">
                    <div class="radio-item" v-for="(item,index) in arrDate" :key="index" @click="getIsfollow('arrDate',index)">
                        <img :src="item.open ? selectImg : noSelectImg" alt="">
                        <div>{{item.name}}</div>
                    </div>
                </div>
                <!-- <div class="more" @click="warningMore">点击查看更多</div> -->

            </div>
            <!-- <div class="bottom_btn">一键导出</div> -->
        </div>
    </div>
</template>

<script>
import resultFilter from "@/components/hvac/performance/project/resultfilter.vue";
import oAnalysisJs from "@/js/hvac/performance/result.js"
import elPerformance from "@/components/common/pagination/index.vue";

export default {
    name: "analysis",
    created() {
        //console.log(this.$route.query)
        //这里出现一个奇怪的Bug Cannot read property 'getAttribute' of null
        //必须加 $nextTick
        //折线图上面的代码报错 导致Chart初始化报错
        //this.$nextTick(() => {
        //$init(() => {
        //Promise.all([ this.getPerformanceOverview(), this.getPerformanceTrend(),this.getPerformanceRank(),this.getPerformanceWarning()]).then((res) => {})
        //Promise.all([this.getPerformanceOverview(),this.getPerformanceTrend(),this.getPerformanceRank()]).then((res) => {})
        //})
        //})
        //切换标签 因为搜索逻辑也会导致这个Bug产生 切换标签暂时无解
        //this.sPhone = this.$route.query.phone
        //this.sPhone = localStorage.getItem("phone")
    },
    components: {
        resultFilter,
        elPerformance
    },
    data() {
        return {
            up: true,
            upIcon: require("@/assets/images/result/up_icon.png"),
            downIcon: require("@/assets/images/result/down_icon.png"),
            warningTab: 0, //预警索引
            warningDateTab: 0, //预警时间索引
            arrWarningTab: [
                { name: "签单手", type: "worker" },
                // { name: "办事处", type: "office" },
                // { name: "省区", type: "province" },
                { name: "渠道", type: "channel" },
            ],
            arrRankTab: [
                // { name: "签单手", type: "worker" },
                // { name: "办事处", type: "office" },
                { name: "代理商", type: "agent" },
                { name: "渠道", type: "channel" },
            ],
            arrMoney: [{ name: "金额", item: "money" }, { name: "项目", item: "project" }],
            arrKedan: [{ name: "获客", item: "client" }, { name: "签单", item: "sign_contract" }],
            tabList: [
                { name: "月粒度", period: "month" },
                { name: "周粒度", period: "week" },
                { name: "日粒度", period: "day" },
            ],
            arrRabid: [
                { name: "金额", open: false, item: "money" },
                { name: "项目", open: true, item: "project" },
                { name: "潜客", open: false, item: "client" },
            ],
            arrDate: [
                { name: "月", open: false, period: "month" },
                { name: "周", open: true, period: "week" },
                { name: "日", open: false, period: "day" },
            ],
            arrYear: [
                { name: "同比", open: true, ratio: "same" },
                { name: "环比", open: false, ratio: "ring" },
            ],
            isFollow: "tb",
            selectImg: require("@/assets/images/result/select.png"),
            noSelectImg: require("@/assets/images/result/noSelect.png"),

            //业绩概览
            oOverview: {},
            //业绩概览筛选参数
            //业绩概览 三个数
            sOverviewNumber: [],
            //趋势
            trendTab: 1, //趋势索引
            //颗粒度 period 颗粒度 值： month-月  week-周  day-日
            sTrendPeriod: "week",
            //money-金额  project-项目  client-潜客
            sTrendItem: "project",
            //same-同比  ring-环比
            sTrendRatio: "same",
            sUpImg: require("@/assets/images/result/up.png"),
            sDownImg: require("@/assets/images/result/down.png"),
            arrTrendX: [],
            arrTrendY: [],
            oTrendChart: null,
            nTrendItem: 0,
            nTrendRratio: 0,
            //业绩榜单 worker 签单手 office 办事处 province 省区 channel 渠道
            sRankType: "agent",
            //项目 money-金额 project-项目
            sRankItem: "project",
            //分页
            nRankPage: 1,
            billboardTab: 0, //榜单索引
            billboardDateTab: 1, //榜单时间索引
            arrRankList: [],
            arrRankTopList: [],
            //搜索表单
            oSearchForm: {
                //...
                agent: "",
                area: "",
                channel: "",
                city: "",
                worker: "",
                start: "",
                end: ""
            },
            //业绩预警
            //签单手 办事处 省区 渠道
            sWarningType: "worker",
            //获客 client  签单 sign_contract
            sWarningItem: "client",
            //月 month  周 week 日 day
            sWarningPeriod: "week",
            nWarningPage: 1,
            arrWarningList: [],
            //sPhone: "",
            arrLegend: "",
            //榜单总页数
            nRankTotal: 0,
            nWarningTotal: 0,
        };
    },
    mounted() {
        //this.createDeliveryLine();
    },
    methods: {
        getSwitch(type, num) {
            let _that = this;
            switch (type) {
                case "trendTab":
                    //业绩趋势
                    //预重复点击
                    if (_that[type] != num) {
                        _that[type] = num;
                        //重新拉取数据
                        _that.sTrendPeriod = this.tabList[num].period
                        _that.getPerformanceTrend()
                    }
                    break;
                case "billboardTab":
                    //榜单
                    // console.log("billboardTab")
                    if (_that[type] != num) {
                        _that[type] = num;
                        _that.nRankPage = 1
                        _that.sRankType = _that.arrRankTab[num].type
                        // console.log(_that.arrRankTab[num])
                        _that.getPerformanceRank()
                    }
                    break;
                case "billboardDateTab":
                    //榜单 金额 项目
                    if (_that[type] != num) {
                        _that[type] = num;
                        _that.nRankPage = 1
                        _that.sRankItem = _that.arrMoney[num].item
                        _that.getPerformanceRank()
                    }
                    break;
                case "warningTab":
                    //预警tab切换
                    if (_that[type] != num) {
                        _that[type] = num;
                        //重新拉取数据
                        _that.sWarningType = this.arrWarningTab[num].type
                        this.nWarningPage = 1;
                        _that.getPerformanceWarning()
                    }
                    break;
                case "warningDateTab":
                    //选择签单/获客
                    if (_that[type] != num) {
                        _that[type] = num;
                        _that.sWarningItem = this.arrKedan[num].item;
                        this.nWarningPage = 1;
                        _that.getPerformanceWarning()
                    }
                    break;
            }
        },
        createDeliveryLine() {
            if (this.oTrendChart != null &&
                this.oTrendChart != "" &&
                this.oTrendChart != undefined) {
                this.oTrendChart.dispose();
            }
            //console.log(document.getElementById('delivery'))
            this.oTrendChart = this.$echarts.init(
                document.getElementById("delivery")
            );
            const OPTIONS = {
                legend: {
                    textStyle: {
                        color: '#333',
                        fontSize: '14'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    y: "19%",
                    y2: "11%",
                    bottom: '35%',
                    left: '13%'
                },
                color: ["#4F84EC", "#65BAC3"],
                xAxis: {
                    type: "category",
                    data: this.arrTrendX,
                    axisLabel: {
                        interval: "auto",
                        rotate: 60,
                        textStyle: {
                            color: "#333",
                            fontSize: '14'
                        },
                        formatter: (value, index) => {
                            return value.replace(/-/g, "/");
                        },
                    }
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        //y轴
                        show: false,
                    },
                    axisTick: {
                        //y轴刻度线
                        show: false,
                    },
                    axisLabel: {
                        textStyle: {
                            color: "#333",
                            fontSize: '14'
                        },
                    }
                },
                series: this.arrTrendY
            };
            this.oTrendChart.setOption(OPTIONS);
        },
        cellStyle(row) {
            if (row.columnIndex === 1) {
                return "color: #222222; fontWeight: 500";
            }
        },
        getIsfollow(type, num) {
            let _that = this;
            _that[type].forEach((it, index) => {
                if (num == index) {
                    it.open = true;
                } else {
                    it.open = false;
                }
            });
            switch (type) {
                case "arrRabid":
                    if (_that.nTrendItem != num) {
                        this.nTrendItem = num
                        this.sTrendItem = this.arrRabid[num].item
                        this.getPerformanceTrend()
                    }
                    break
                case "arrYear":
                    if (_that.nTrendRratio != num) {
                        this.nTrendRratio = num
                        this.sTrendRatio = this.arrYear[num].ratio
                        //console.log(this.sTrendRatio)
                        //console.log(num)
                        this.getPerformanceTrend()
                    }
                    break
                case "arrDate":
                    const period = this.arrDate[num].period
                    if (_that.sWarningPeriod != period) {
                        this.sWarningPeriod = period;
                        this.nWarningPage = 1;
                        this.getPerformanceWarning();
                    }
                    break
            }
        },
        //业绩概览
        getPerformanceOverview() {
            this.$store.commit("loadSwitch", true);
            let data = {
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
                //skip_phone: this.sPhone
            }
            oAnalysisJs.getPerformanceOverview(data).then(res => {
                this.$store.commit("loadSwitch", false);
                this.oOverview = res.data.data.result
            })
        },
        //业绩趋势
        getPerformanceTrend() {
            this.$store.commit("loadSwitch", true);
            let data = {
                period: this.sTrendPeriod,
                item: this.sTrendItem,
                ratio: this.sTrendRatio,
                //搜索
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
                //skip_phone: this.sPhone
            }
            oAnalysisJs.getPerformanceTrend(data).then(res => {
                this.$store.commit("loadSwitch", false);
                //处理数据
                let data = res.data.data.result
                this.sOverviewNumber = data.card
                this.arrTrendX = data.x_axis
                //this.arrTrendY=data.series
                //当前
                let arrCurrent = []
                //过去
                let arrBefore = []
                data.series.forEach(item => {
                    arrCurrent.push(item.cur_val)
                    arrBefore.push(item.before_val)
                })
                this.arrTrendY = [{ name: "当前", data: arrCurrent, type: "line" }, { name: this.sTrendRatio == "same" ? "同比" : "环比", data: arrBefore, type: "line" }]
                this.createDeliveryLine()

            })
        },
        //业绩榜单
        getPerformanceRank() {
            this.$store.commit("loadSwitch", true);
            let data = {
                type: this.sRankType,
                item: this.sRankItem,
                page: this.nRankPage,
                //搜索
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
                //skip_phone: this.sPhone
            }
            oAnalysisJs.getPerformanceRank(data).then(res => {
                this.$store.commit("loadSwitch", false);
                let result = res.data.data.result
                //增加单位
                result.list.forEach(item => {
                    item.value = item.value + (this.sRankItem === "money" ? '万' : '个')
                })

                if (this.nRankPage == 1) {
                    this.arrRankTopList = []
                    this.arrRankList = []
                    //前三名
                    result.list.forEach((item, index) => {
                        if (index < 3) {
                            this.arrRankTopList.push(item)
                        } else {
                            this.arrRankList.push(item)
                        }
                    })
                    //this.arrRankTopList=result.list.slice(0,3)
                    //this.arrRankList=result.list.slice(3)
                } else {
                    if (result.list.length) {
                        this.arrRankList = result.list
                    } else {
                        this.$toast("暂无数据")
                    }
                }
                this.nRankTotal = Number(result.total_page)

            })
        },
        //业绩预警
        getPerformanceWarning() {
            this.$store.commit("loadSwitch", true);
            let data = {
                type: this.sWarningType,
                item: this.sWarningItem,
                period: this.sWarningPeriod,
                page: this.nWarningPage,
                //搜索
                agent: this.oSearchForm.agent,
                area: this.oSearchForm.area,
                channel: this.oSearchForm.channel,
                city: this.oSearchForm.city,
                worker: this.oSearchForm.worker,
                start: this.oSearchForm.start,
                end: this.oSearchForm.end,
                //skip_phone: this.sPhone
            }
            oAnalysisJs.getPerformanceWarning(data).then(res => {
                this.$store.commit("loadSwitch", false);
                let result = res.data.data.result;
                // if (this.nWarningPage == 1) {
                //     this.arrWarningList = result.list;
                // } else {
                //     if (result.list.length) {
                //         this.arrWarningList = this.arrWarningList.concat(result.list);
                //     } else {
                //         this.$toast("暂无数据");
                //     }
                // }
                this.arrWarningList = result.list;
                this.nWarningTotal = Number(result.totalPages)

            })
        },
        // rankMore() {
        //     this.nRankPage++
        //     this.getPerformanceRank()
        // },
        // warningMore() {
        //     this.nWarningPage++;
        //     this.getPerformanceWarning();
        // },
        getSearchForm(val) {
            //刷新页面所有接口
            this.oSearchForm = val
            console.log(val)
            this.getPerformanceOverview()
            this.getPerformanceTrend()
            this.getPerformanceRank()
            this.getPerformanceWarning()
        },
        // 点击页数
        getRankActive(page) {
            let _that = this;
            _that.nRankPage = page;
            _that.getPerformanceRank();
        },
        // 上一页
        lastRank(page) {
            let _that = this;
            _that.nRankPage = page;
            _that.getPerformanceRank();
        },
        // 下一页
        nextRank(page) {
            let _that = this;
            _that.nRankPage = page;
            _that.getPerformanceRank();
        },
        //处理下分页导致排名问题
        rankHandler(val) {
            if (this.nRankPage == 1) {
                return "No." + (val + 4)
            } else {
                return "No." + ((val + 1) + (this.nRankPage - 1) * 10)
            }
        },
        getWarningActive(page) {
            let _that = this;
            _that.nWarningPage = page;
            _that.getPerformanceWarning();
        },
        // 上一页
        lastWarning(page) {
            let _that = this;
            _that.nWarningPage = page;
            _that.getPerformanceWarning();
        },
        // 下一页
        nextWarning(page) {
            let _that = this;
            _that.nWarningPage = page;
            _that.getPerformanceWarning();
        },
        //处理下分页导致排名问题
        warningHandler(val) {
            return "No." + ((val + 1) + (this.nWarningPage - 1) * 10)
        }
    },
};
</script>

<style lang="scss" scoped>
#delivery {
    width: 100%;
    height: 448px;
}
.analysis_content {
    width: 100%;
    padding: 0 24px 24px;
    box-sizing: border-box;
    .bottom_btn {
        width: 100%;
        border-radius: 12px;
        background: linear-gradient(136deg, #4ea062 0%, #338444 100%);
        height: 92px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 28px;
        margin-top: 32px;
    }
    .xian {
        border-top: 1px dashed #f1f1f1;
        margin: 40px 0;
    }
    .analysis_warp {
        width: 100%;
        background: #fff;
        border-radius: 12px;
        padding: 18px 18px;
        box-sizing: border-box;
        margin-top: 24px;
        &:first-child {
            margin-top: 0;
        }
        // .more {
        //     text-align: center;
        //     color: #444444;
        //     font-size: 24px;
        //     margin-top: 28px;
        //     margin-bottom: 10px;
        // }
        .page-wrap {
            margin: 0 auto;
            margin-top: 24px;
            overflow: hidden;
        }
        .analysis_title {
            font-size: 28px;
            font-weight: 700;
            color: #222222;
            span {
                font-weight: 500;
                color: #666;
            }
        }
        .result-tab-wrap {
            margin-top: 28px;
            width: 100%;
            box-sizing: border-box;
            border-top: 1px solid #f7f7f7;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            background: #fff;
            border: 2px solid $deepGreen;
            border-radius: 8px;
            overflow: hidden;

            .result-tab-item {
                width: 33.33%;
                height: 64px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: $deepGreen;
                line-height: 64px;
                text-align: center;
                border-left: 1px solid $deepGreen;
                &:first-child {
                    border: 0;
                }
            }

            .result-tab-item-act {
                background: $deepGreen;
                color: #ffffff;
                border: none;
            }
        }
        .radio_content {
            display: flex;
            justify-content: space-between;
            margin-top: 28px;
        }
        .contribute-table {
            width: 100%;
            margin-top: 28px;
            .yj {
                color: #eb6f56;
            }
            .name {
                color: #222222;
                font-weight: 700;
            }
            .amount {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #318544;
                line-height: 32px;
            }
        }
        .follow-table {
            width: 100%;
            border-radius: 12px;
            margin-top: 40px;
            overflow: hidden;
            .follow-table-top {
                width: 100%;
                display: flex;
                align-items: center;
                background: #318544;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 70px;

                .follow-table-top-item {
                    width: 33.33%;
                    border-right: 2px solid rgba(255, 255, 255, 0.15);

                    &:last-child {
                        border-right: none;
                    }
                }
            }

            .follow-table-bottom {
                display: flex;
                align-items: center;
                border: 2px solid #6c9276;
                border-radius: 0 0 12px 12px;
                border-top: none;

                .follow-table-bottom-item {
                    width: 33.33%;
                    border-right: 2px solid #6c9276;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 32px;
                        height: 32px;
                        margin-right: 12px;
                    }

                    div {
                        font-size: 28px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #318544;
                        line-height: 70px;
                    }

                    .up {
                        color: #318544;
                    }
                    .down {
                        color: #eb6f56;
                    }

                    &:last-child {
                        border: none;
                    }
                }
            }
        }
        .result_board {
            display: flex;
            justify-content: space-between;
        }
        .ranking {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: 46px;
            .ranking_item {
                width: 208px;
                overflow: hidden;
                border-radius: 12px;
                .rank_header_img {
                    margin-top: 18px;
                    width: 190px;
                    height: 146px;
                    background: url("~@/assets/images/pagin/crown_icon.png")
                        no-repeat center/100% 100%;
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .header_url {
                        position: absolute;
                        bottom: 17px;
                        box-sizing: border-box;
                        width: 106px;
                        height: 106px;
                        border-radius: 50%;
                        overflow: hidden;
                        img {
                            width: 100%;
                            border: 5px solid #fff;
                            border-radius: 50%;
                        }
                    }
                    .rank_header_num {
                        width: 68px;
                        height: 28px;
                        background: #fed14e;
                        border-radius: 14px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 22px;
                        color: #fff;
                        position: absolute;
                        bottom: 0;
                    }
                }
                .rank_name {
                    color: #fed14e;
                    font-size: 28px;
                    margin-top: 26px;
                    padding: 10px;
                }
                .rank_address {
                    font-size: 24px;
                    color: #fff;
                    padding: 0 10px;
                    // width: 80%;
                    word-wrap: break-word;
                    text-align: center;
                }
                .rank_header {
                    height: 300px;
                    width: 100%;
                    border-radius: 12px;
                    position: relative;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    background: linear-gradient(
                        to bottom,
                        #59b36f,
                        #6cb77e,
                        #82be90,
                        #9cc8a6,
                        #b7d5be
                    );
                }
                .rank_content {
                    display: flex;
                    align-items: flex-end;
                }
                .rank_content_one {
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                }
                .rank_num_two {
                    margin-top: -10px;
                    padding: 14px 0;
                    box-sizing: border-box;
                    width: 100%;
                    background: #f0f4f1;
                    border-radius: 12px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    color: $deepGreen;
                    font-weight: 700;
                }
                .rank_num_one {
                    margin-top: -10px;
                    width: 100%;
                    height: 144px;
                    background: #f0f4f1;
                    border-radius: 12px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    font-size: 28px;
                    color: $deepGreen;
                    font-weight: 700;
                    .set_num_one {
                        margin-left: 10px;
                        font-size: 48px;
                    }
                }
                .rank_sumpmer {
                    font-size: 28px;
                    color: #fff;
                    margin-top: 16px;
                }
                .rank_sumpmer_one {
                    color: #fed14e;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &::before {
                        content: "";
                        display: flex;
                        width: 42px;
                        height: 42px;
                        background: url("~@/assets/images/ant/huangguan.png")
                            no-repeat center/100%;
                    }
                }
                .rank_number {
                    font-size: 45px;
                    color: #fff;
                    font-weight: 700;
                    margin-top: 14px;
                }
                .rank_num {
                    width: 100%;
                    height: 72px;
                    background: #f0f4f1;
                    border-radius: 12px;
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 24px;
                    color: $deepGreen;
                    .set_num {
                        margin-left: 10px;
                        font-size: 32px;
                        font-weight: 700;
                    }
                }
                .rank_header_one {
                    position: relative;
                    z-index: 1;
                    height: 300px;
                    border-radius: 12px;
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    background: linear-gradient(
                        to bottom,
                        #51af68,
                        #4ca962,
                        #48a25d,
                        #449c58,
                        #409653
                    );
                }
            }
        }
        .radio-wrap {
            display: flex;
            padding: 18px 0;
            justify-content: space-around;
            align-items: center;
            border-radius: 12px;
            border: 2px solid #dbdbdb;
            &:last-child {
                width: 38%;
            }
            &:first-child {
                width: 60%;
            }
        }
        .contribute_radio {
            display: flex;
            align-items: center;
            justify-content: space-around;
            margin-top: 30px;
            padding: 0 90px;
            box-sizing: border-box;
        }
        .radio-item {
            display: flex;
            align-items: center;
            img {
                width: 36px;
                height: 36px;
                margin-right: 8px;
            }

            div {
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #444444;
                line-height: 40px;
            }
        }
        .agent_warp_content {
            margin-top: 24px;
            margin-bottom: 24px;
            padding-bottom: 32px;
            border-bottom: 1px dashed #f1f1f1;
            .detailed {
                margin-top: 32px;
                text-align: center;
                box-sizing: border-box;
                color: #444444;
                font-size: 24px;
            }
            .agent {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .agent_content {
                    width: 33.33%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .agent_warp {
                        width: 202px;
                        padding: 36px 0;
                        box-sizing: border-box;
                        background: #f7f7f7;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        border-radius: 16px;
                        div {
                            font-size: 28px;
                            color: #858585;
                        }
                        .agent_num {
                            color: #318544;
                            margin-top: 24px;
                            font-size: 48px;
                            font-weight: 700;
                        }
                    }
                }
            }
        }
    }
    .flc-scope {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .amount {
            width: 65%;
            font-size: 24px;
        }
    }
    .flc {
        display: flex;
        align-items: center;
        img {
            width: 28px;
            height: 28px;
        }
        div {
            font-size: 24px;
        }
    }
}
.page-wrap {
    margin: 0 auto;
    margin-top: 24px;
    overflow: hidden;
}
</style>